(function () {
  let returnFocus = null;
  let restoreScroll = false;
  let searchSessionOpen = false;

  const getModal = () => document.getElementById("search-modal");
  const hasActiveOverlay = () => Boolean(
    document.querySelector("quick-add-modal[open], modal-dialog[open], cart-drawer.active")
  );
  const isVisible = (element) =>
    element.isConnected &&
    element.getClientRects().length > 0 &&
    !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
    getComputedStyle(element).visibility !== "hidden";
  const getFocusable = (modal) =>
    Array.from(
      modal.querySelectorAll(
        'a[href], button, input:not([type="hidden"]), select, textarea, summary, [tabindex]'
      )
    ).filter((element) => !element.disabled && element.tabIndex >= 0 && isVisible(element));

  const overlayObserver = new MutationObserver((mutations) => {
    if (!mutations.some(({ target }) => target.id === "search-modal" || target.matches("quick-add-modal, modal-dialog, cart-drawer"))) return;
    const modal = getModal();
    if (!modal || !searchSessionOpen) return;
    if (hasActiveOverlay()) {
      modal.inert = true;
      modal.setAttribute("aria-hidden", "true");
      setTriggerState(false);
      return;
    }
    if (!modal.classList.contains("active")) {
      modal.classList.add("active");
      document.querySelector(".search-modal__mask")?.classList.add("active");
    }
    modal.inert = false;
    modal.setAttribute("aria-hidden", "false");
    setTriggerState(true);
    document.body.classList.add("overflow-hidden");
    if (!modal.contains(document.activeElement) || !isVisible(document.activeElement)) {
      (getFocusable(modal)[0] || modal).focus();
    }
  });

  function setTriggerState(isOpen) {
    document.querySelectorAll(".search-modal-trigger").forEach((trigger) => {
      trigger.setAttribute("aria-haspopup", "dialog");
      trigger.setAttribute("aria-controls", "search-modal");
      trigger.setAttribute("aria-expanded", String(isOpen));
    });
  }

  function openSearch(trigger) {
    const modal = getModal();
    if (!modal || modal.classList.contains("active")) return;
    searchSessionOpen = true;
    returnFocus = trigger;
    restoreScroll = !document.body.classList.contains("overflow-hidden");
    modal.inert = false;
    modal.setAttribute("aria-hidden", "false");
    modal.classList.add("active");
    document.querySelector(".search-modal__mask")?.classList.add("active");
    document.body.classList.add("overflow-hidden");
    setTriggerState(true);
    overlayObserver.observe(document.body, { attributes: true, attributeFilter: ["open", "class"], subtree: true });
    (modal.querySelector(".search__input") || getFocusable(modal)[0] || modal).focus();
  }

  function closeSearch() {
    const modal = getModal();
    if (!modal || !searchSessionOpen) return;
    searchSessionOpen = false;
    overlayObserver.disconnect();
    modal.querySelectorAll("predictive-search").forEach((search) => search.close?.());
    modal.classList.remove("active");
    document.querySelector(".search-modal__mask")?.classList.remove("active");
    if (restoreScroll && !hasActiveOverlay()) document.body.classList.remove("overflow-hidden");
    setTriggerState(false);
    const target = returnFocus && isVisible(returnFocus)
      ? returnFocus
      : Array.from(document.querySelectorAll(".search-modal-trigger")).find(isVisible);
    target?.focus();
    modal.inert = true;
    modal.setAttribute("aria-hidden", "true");
    returnFocus = null;
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".search-modal-trigger");
    if (trigger) {
      if (!getModal()) return;
      event.preventDefault();
      openSearch(trigger);
    } else if (event.target.closest(".search-modal__mask, .search-modal__close")) {
      event.preventDefault();
      closeSearch();
    }
  });

  document.addEventListener("keydown", (event) => {
    const modal = getModal();
    if (!modal?.classList.contains("active") || hasActiveOverlay()) return;
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
      return;
    }
    if (event.key !== "Tab") return;
    const focusable = getFocusable(modal);
    const first = focusable[0] || modal;
    const last = focusable[focusable.length - 1] || modal;
    const active = document.activeElement;
    if (!focusable.length || !modal.contains(active) || active === modal) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener("focusin", (event) => {
    const modal = getModal();
    if (modal?.classList.contains("active") && !hasActiveOverlay() && !modal.contains(event.target)) {
      (getFocusable(modal)[0] || modal).focus();
    }
  });

  function initializeSearch() {
    const modal = getModal();
    if (!modal) return;
    const isOpen = modal.classList.contains("active");
    modal.inert = !isOpen;
    modal.setAttribute("aria-hidden", String(!isOpen));
    setTriggerState(isOpen);
  }

  document.addEventListener("shopify:section:load", initializeSearch);
  initializeSearch();
})();
